import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "react-bootstrap";
import { formatCurrency } from "../../helpers/utils";
import { TablePlaceholder } from "../../components/placeholders";
import CustomLoader from "../../components/loader";

const COLUMN_WIDTHS = {
  date: "30%",
  code: "20%",
  address: "30%",
  amount: "20%",
};

export default function HistoryTable({
  items,
  onEndReached,
  hasMore,
  loading,
  onRowClick,
}) {
  return (
    <div className="table-responsive-sm">
      <InfiniteScroll
        dataLength={items.length}
        next={onEndReached}
        hasMore={hasMore}
        scrollThreshold={0.9}
        loader={
          <div className="text-center p-2">
            <CustomLoader fontSize={32} />
          </div>
        }
      >
        <table className="table table-centered mb-0">
          <thead>
            <tr>
              <th className="text-center" style={{ width: COLUMN_WIDTHS.date }}>
                Огноо
              </th>
              <th className="text-center" style={{ width: COLUMN_WIDTHS.code }}>
                Код
              </th>
              <th
                className="text-center"
                style={{ width: COLUMN_WIDTHS.address }}
              >
                Хаяг
              </th>
              <th
                className="text-center"
                style={{ width: COLUMN_WIDTHS.amount }}
              >
                Нийт үнэ
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <TablePlaceholder count={6} />
            ) : (
              items.map((item) => {
                const isCompany = item?.ebarimtType === "COMPANY";
                const register = item?.ebarimtRegister;

                return (
                  <tr
                    key={item.id}
                    onClick={() => onRowClick && onRowClick(item)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Огноо + статус */}
                    <td className="text-center">
                      <div>{item.createdAt}</div>
                      <div
                        className="text-muted"
                        style={{
                          fontSize: 12,
                          lineHeight: "14px",
                          marginTop: 2,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 140,
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                        title={item?.status?.name || ""}
                      >
                        {item?.status?.name || "-"}
                      </div>
                    </td>

                    {/* Код + Байгууллага / Хувь хүн */}
                    <td className="text-center">
                      <div>{`#${item.orderCode}`}</div>

                      <div
                        className="text-muted"
                        style={{
                          fontSize: 12,
                          lineHeight: "14px",
                          marginTop: 2,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 140,
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                        title={
                          isCompany && register
                            ? `Байгууллага | ${register}`
                            : "Хувь хүн"
                        }
                      >
                        <span style={{ fontWeight: 600 }}>
                          {isCompany ? "Байгууллага" : "Хувь хүн"}
                        </span>
                        {isCompany && register && (
                          <span> | {register}</span>
                        )}
                      </div>
                    </td>

                    {/* Хаяг */}
                    <td className="text-center">
                      {item?.district?.name} {item.address}
                    </td>

                    {/* Нийт үнэ */}
                    <td className="text-center">
                      {formatCurrency(item.totalAmount)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  );
}
